//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { Alert } from '@components/atoms/alert/Alert';

export const UnexpectedErrorAlert = () => {
  return (
    <ErrorAlert>
      An unexpected error occurred. Please try again or contact Bazaarvoice
      Support.
    </ErrorAlert>
  );
};

const ErrorAlert = styled(Alert).attrs({ type: 'error' })(
  ({ theme }) => `
    margin: ${theme.spacings[3]};
  `,
);
